// Build a download filename like "cash-flow-2026-05-16" from an artifact
// title. Used by chart and table artifacts when exporting PNG/CSV/XLSX.
export function buildArtifactFilename(
  title: string | null | undefined,
  fallback: string,
): string {
  const today = new Date().toISOString().slice(0, 10)
  const slug = (title ?? fallback)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60)
  return `${slug || fallback}-${today}`
}
